export default class BackgroundInstance {
  public constructor(
    public panelStyles: { [key: string]: string; },
    public panelClasses: { [key: string]: boolean; },
    public primeVideoUrl: string = '',
    public altVideoUrl: string = ''
  ) { }
}
